<a name="customScormClose" id="customScormClose" (click)="closeScorm()"><span>Close</span></a>